export class CenterAlertIotDevice {

    private internalId: string;
    private deviceName: string;

    constructor(internalId?: string, deviceName?: string) {
        this.internalId = internalId;
        this.deviceName = deviceName;
    }

    public get InternalId() {
        return this.internalId;
    }
    public get DeviceName() {
        return this.deviceName;
    }
    public set InternalId(internalId) {
        this.internalId = internalId;
    }
    public set DeviceName(deviceName) {
        this.deviceName = deviceName;
    }
}

